import React, { useEffect, useState } from 'react';
import OlcButton from '~/components/General/OlcButton';

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { fetchContactImports } from '~/redux/actions/contact-import-actions';

// Utils
import { MESSAGES } from '~/utils/message';
import { DEFAULT_PAGINATION } from '~/utils/constants';

// Component
import ContactImportTable from './ImportTable';

// MUI Components
import { Box, Typography } from '@mui/material';

// Icons
import { ImportLightCIcon } from '~/assets/images';

// Styles
import './styles.scss';
import { useNavigate } from 'react-router-dom';

const Import = () => {
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    let payload = {
      page: pagination?.page || DEFAULT_PAGINATION.page,
      pageSize: pagination?.pageSize || DEFAULT_PAGINATION.pageSize,
    };
    dispatch(fetchContactImports(payload));
  }, [pagination.page, pagination.pageSize]);

  return (
    <>
      <Box className="importWrapper">
        <Box
          className="headerWrap"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            '@media (max-width: 1199px)': {
              paddingTop: '20px',
            },
          }}
        >
          <Box className="ImportsRow">
            <Typography variant="h4">{MESSAGES.ACCOUNT.CONTACT_IMPORT.TITLE}</Typography>
          </Box>
          {
            <Box className="inviteBtn">
              <OlcButton
                variant="primary"
                sx={{ '&:hover': { backgroundColor: '#ed5c2f' } }}
                onClick={() => {
                  navigate('/contacts/import');
                }}
              >
                <img src={ImportLightCIcon} alt="import" />
                <Typography>{MESSAGES.CONTACTS.NO_CONTACTS_SCREEN.IMPORT_BTN_TEXT}</Typography>
              </OlcButton>
            </Box>
          }
        </Box>
        <ContactImportTable pagination={pagination} updatePagination={setPagination} />
      </Box>
    </>
  );
};

export default Import;
